import * as actionTypes from '../actions/actionTypes';

const initialState = {
    token: localStorage.getItem('token'),
    arbiAgreement:null,
    getAllAgreement: null,
    agreements:null,
    loading:null
};

const arbiAgreementReducer = (state = initialState, action) => {
    // console.log('action arbiAgreementReducer action: '+JSON.stringify(action))
    switch (action.type) {
        case actionTypes.ARBI_AGREEMENT_SUCCESS:
            return {
                ...state,
                arbiAgreement:true,
            };
        case actionTypes.ARBI_AGREEMENT_FAIL:
            return {
                ...state,
                arbiAgreement: false,
            };
        case actionTypes.ARBI_GETALLAGREEMENT_SUCCESS:
            return {
                ...state,
                getAllAgreement: true,
                agreements: action.agreements
            }
        case actionTypes.ARBI_GETALLAGREEMENT_FAIL:
            return{
                ...state,
                getAllAgreement: false
            }
        case actionTypes.ARBI_GETALLAGREEMENT_NOTLOADING:
            return{
                ...state,
                loading:false
            }
        case actionTypes.ARBI_GETALLAGREEMENT_LOADING:
            return {
                ...state,
                loading:true
            }
        default:
            return state;
    }
};

export default arbiAgreementReducer;